import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

function Index() {
  const { t } = useTranslation();

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
      config: { duration: 500 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [fourthRef, fourthRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.4, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.cloudcontain}>
      <div className={css.maintitle}>{t("分账系统")}</div>

      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.inner} style={firstRefStyle}>
          <div className={`${css.subtitle} ${css.none}`}>
            {t("$singlee_fz1")}
          </div>
          <div className={css.boxzone}>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_fz18")}</div>
              <div className={css.text}>{t("$singlee_fz2")}</div>
              <div className={css.rb}>01</div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_fz19")}</div>
              <div className={css.text}>{t("$singlee_fz3")}</div>
              <div className={css.rb}>02</div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_fz20")}</div>
              <div className={css.text}>{t("$singlee_fz4")}</div>
              <div className={css.rb}>03</div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_fz21")}</div>
              <div className={css.text}>{t("$singlee_fz5")}</div>
              <div className={css.rb}>04</div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_fz22")}</div>
              <div className={css.text}>{t("$singlee_fz6")}</div>
              <div className={css.rb}>05</div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          <div className={`${css.subtitle}`}>{t("应用价值")}</div>
          <div className={css.content}>
            <div className={css.left}></div>
            <div className={css.right}>
              <div className={css.item}>
                <div className={css.index}>01</div>
                <div className={css.icon}>
                  <div className={css.m1}></div>
                </div>
                <div className={css.desc}>{t("$singlee_fz7")}</div>
              </div>
              <div className={css.item}>
                <div className={css.index}>02</div>
                <div className={css.icon}>
                  <div className={css.m2}></div>
                </div>
                <div className={css.desc}>{t("$singlee_fz8")}</div>
              </div>
              <div className={css.item}>
                <div className={css.index}>03</div>
                <div className={css.icon}>
                  <div className={css.m3}></div>
                </div>
                <div className={css.desc}>{t("$singlee_fz9")}</div>
              </div>
              <div className={css.item}>
                <div className={css.index}>04</div>
                <div className={css.icon}>
                  <div className={css.m4}></div>
                </div>
                <div className={css.desc}>{t("$singlee_fz10")}</div>
              </div>
              <div className={css.item}>
                <div className={css.index}>05</div>
                <div className={css.icon}>
                  <div className={css.m5}></div>
                </div>
                <div className={css.desc}>{t("$singlee_fz11")}</div>
              </div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <animated.div className={css.inner} style={thirdRefStyle}>
          <div className={css.subtitle}>{t("适用场景")}</div>
          <div className={css.content}>
            <div className={css.left}>
              <div className={css.text}>
                {t("$singlee_fz12")}
                <br />
                {t("$singlee_fz13")}
              </div>
            </div>
            <div className={css.right}>
              <div className={css.text}>
                {t("$singlee_fz12")}
                <br />
                <br />
                {t("$singlee_fz13")}
              </div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.fourth} ref={fourthRef}>
        <div className={css.inner}>
          <div className={css.subtitle}>{t("部分合作案例")}</div>
          <animated.div className={css.box} style={fourthRefStyle}>
            <div className={css.item}>{t("$singlee_fz14")}</div>
            <div className={css.item}>{t("$singlee_fz15")}</div>
            <div className={css.item}>{t("$singlee_fz16")}</div>
            <div className={css.item}>{t("$singlee_fz17")}</div>
          </animated.div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Index);
